export function CarouselIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.87354 7.87354C3.87354 6.21668 5.21668 4.87354 6.87354 4.87354H16.877C18.5338 4.87354 19.877 6.21668 19.877 7.87354V17.877C19.877 19.5338 18.5338 20.877 16.877 20.877H6.87354C5.21668 20.877 3.87354 19.5338 3.87354 17.877V7.87354ZM6.87354 6.87354C6.32125 6.87354 5.87354 7.32125 5.87354 7.87354V17.877C5.87354 18.4292 6.32125 18.877 6.87354 18.877H16.877C17.4292 18.877 17.877 18.4292 17.877 17.877V7.87354C17.877 7.32125 17.4292 6.87354 16.877 6.87354H6.87354ZM23 19.0001C22.4477 19.0001 22 18.5523 22 18.0001V8.00006C22 7.44778 22.4477 7.00006 23 7.00006C23.5523 7.00006 24 7.44778 24 8.00006V18.0001C24 18.5523 23.5523 19.0001 23 19.0001ZM0 18.0001C0 18.5523 0.447715 19.0001 1 19.0001C1.55228 19.0001 2 18.5523 2 18.0001V8.00006C2 7.44778 1.55228 7.00006 1 7.00006C0.447715 7.00006 0 7.44778 0 8.00006V18.0001Z"
      />
    </svg>
  );
}
